import React, { useEffect } from 'react';
import Hero from '../components/Hero';
import Locations from '../components/Locations';
import PriceList from '../components/PriceList';
import MaterialsGallery from '../components/MaterialsGallery';
import HowToBuy from '../components/HowToBuy';
import FacebookSection from '../components/FacebookSection';

const Home = () => {
  useEffect(() => {
    document.title = 'På Pladsen';

    // Meta description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = '';

    // Open Graph Title
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitle);
    }
    ogTitle.content = 'På Pladsen';

    // Open Graph Description
    let ogDesc = document.querySelector('meta[property="og:description"]');
    if (!ogDesc) {
      ogDesc = document.createElement('meta');
      ogDesc.setAttribute('property', 'og:description');
      document.head.appendChild(ogDesc);
    }
    ogDesc.content = '';

    // Open Graph Image
    let ogImage = document.querySelector('meta[property="og:image"]');
    if (!ogImage) {
      ogImage = document.createElement('meta');
      ogImage.setAttribute('property', 'og:image');
      document.head.appendChild(ogImage);
    }
    ogImage.content = '';
  }, []);

  return (
    <div className="min-h-screen bg-white font-sans text-zinc-900 selection:bg-brand/20 selection:text-brand">
      <main>
        <Hero />
        <Locations />
        <PriceList />
        <MaterialsGallery />
        <HowToBuy />
        <FacebookSection />
      </main>
    </div>
  );
};

export default Home;
